var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "input",
    attrs: {
      "data-type": "input"
    }
  }, [_vm.showImageLoader ? _c('PreviewImage', {
    attrs: {
      "input-name": _vm.inputName
    }
  }) : _vm._e(), _c('input', {
    directives: [{
      name: "replace",
      rawName: "v-replace",
      value: /\s/,
      expression: "/\\s/"
    }],
    class: {
      'invalid': _vm.$v.$error
    },
    attrs: {
      "id": _vm.inputId,
      "size": _vm.inputSize,
      "type": "url",
      "title": _vm.inputTitle,
      "placeholder": _vm.inputPlaceholder,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.inputHandler,
      "focus": function focus($event) {
        return _vm.$emit('focus');
      },
      "blur": function blur($event) {
        return _vm.$emit('blur');
      }
    }
  }), _c('label', {
    attrs: {
      "for": _vm.inputId
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.inputName) + " ")]), _vm.isCounter(this.showCounter, this.maxLength, this.value) ? _c('span', [_vm._v(" " + _vm._s(_vm.getCounter(this.maxLength, this.value)) + " ")]) : _vm._e(), _vm.$v.$error ? _c('span', {
    staticClass: "validation",
    attrs: {
      "title": _vm.getValidationInfo(_vm.$v)
    }
  }, [_c('mark')]) : _vm._e(), _vm.readonly ? _c('span', {
    staticClass: "lock"
  }, [_c('mark')]) : _vm._e(), _vm.capustaInfo ? _c('a', {
    staticClass: "hint",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.$showInfo(_vm.capustaInfo);
      }
    }
  }) : _vm._e()]), _vm._t("link")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }